import { SettingOutlined } from "@ant-design/icons";
import { Button, Modal, message } from "antd";
import { useEffect, useState } from "react";
import "./TVTokenSettings.css";
import TVTokenTable from "./TVTokenTable/TVTokenTable";

import { useSelector } from "react-redux";
import {
  CreateTVToken,
  DeleteTVToken,
  GetTVTokenList,
  UpdateTVToken,
} from "../../../services/common/cnc_apis";
import lang from "../../../services/lang";
import TVTokenDialog from "./TVTokenDialog/TVTokenDialog";

function TVTokenSettings(props) {
  const { langIndex } = useSelector((state) => state.app);
  const authData = useSelector((state) => state.authService);
  const { showModal, setShowModal, selCustomerId, customerInfo } = props;
  const [isShowModal, setIsShowModal] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const [initTokenInfo, setInitTokenInfo] = useState(null);

  useEffect(() => {
    if (showModal && selCustomerId) {
      GetTVTokenList(selCustomerId, (tokenList) => {
        if (tokenList != null && tokenList.length > 0) {
          tokenList.forEach(function (entry) {
            entry.key = entry.id;
          });
          setTokenList(tokenList);
        } else {
          setTokenList([]);
        }
      });
    }
  }, [showModal, selCustomerId]);

  const deleteToken = (id) => {
    DeleteTVToken({ customer_id: selCustomerId, id: id }, (res) => {
      if (res == true) {
        const newData = tokenList.filter((element) => element.id != id);
        setTokenList(newData);
        message.success(lang(langIndex, "msg_delete_success"));
      } else {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    });
  };

  const onClickEditRecord = (record) => {
    setInitTokenInfo(record);
    setIsShowModal(true);
  };

  const onClickAddToken = () => {
    setInitTokenInfo(null);
    setIsShowModal(true);
  };

  const addToken = (info) => {
    info["customer_id"] = selCustomerId;
    // Add created_by_user_id from current logged-in user
    if (authData && authData.user_id) {
      info["created_by_user_id"] = authData.user_id;
    }

    //console.log("addToken info", info);
    //console.log("addToken authData", authData);
    
    CreateTVToken(info, (res) => {
      if (res != null) {
        setTokenList([...tokenList, res]);
        message.success(lang(langIndex, "msg_add_success"));
        setIsShowModal(false);
      } else {
        message.error(lang(langIndex, "msg_something_wrong"));
      }
    });
  };

  const editToken = (info) => {
    info["customer_id"] = selCustomerId;
    const newData = [...tokenList];
    const index = newData.findIndex((item) => item.key === info.key);
    if (index > -1) {
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...info });
      UpdateTVToken(info, (res) => {
        if (res != null) {
          setTokenList(newData);
          message.success(lang(langIndex, "msg_update_success"));
          setIsShowModal(false);
        } else {
          message.error(lang(langIndex, "msg_something_wrong"));
        }
      });
    } else {
      message.error(lang(langIndex, "msg_something_wrong"));
    }
  };

  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <Modal
      centered
      visible={showModal}
      title={null}
      onCancel={() => onCancel()}
      onOk={() => onCancel()}
      okText={lang(langIndex, "plant_update")}
      closable={true}
      className="customer-setting-dialog-style"
      destroyOnClose={true}
      footer={null}
      width={970}
    >
      <div className="customer-setting-page-title">
        <SettingOutlined />
        <span style={{ marginLeft: 10 }} />
        {lang(langIndex, "plant_tv_token_settings")}
      </div>

      <div
        className="content-scrollbar-style user-setting-container"
        style={{ overflow: "auto" }}
      >
        {isShowModal === true && (
          <TVTokenDialog
            initTokenInfo={initTokenInfo}
            addToken={addToken}
            editToken={editToken}
            isShowModal={isShowModal}
            setIsShowModal={setIsShowModal}
            selCustomerId={selCustomerId}
          />
        )}
        <div className="user-setting-button-container">
          <Button
            ghost
            onClick={() => {
              onClickAddToken();
            }}
          >
            {lang(langIndex, "tv_token_add_new")}
          </Button>
        </div>
        <div className="user-setting-user-table-style">
          <TVTokenTable
            tokenList={tokenList}
            deleteToken={deleteToken}
            onClickEditRecord={onClickEditRecord}
            selCustomerId={selCustomerId}
          />
        </div>
      </div>
    </Modal>
  );
}

export default TVTokenSettings;

